import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from 'vuex-module-decorators';
import store from '@/store';
import goalService from '@/services/common/goal.service';

@Module({ namespaced: true, name: 'goal', store, dynamic: true })
class GoalModule extends VuexModule {
  public goalData: any[] = []

  @MutationAction({ mutate: ['goalData'], rawError: true })
  async loadGoals(data: {
    coachId?: string;
    coachClientId?: string;
    coachClientDepartment?: string;
    coachClientCompanyName?: string;
  }) {
    const goalData = (await goalService.loadGoals(
      data
    )) as any;
    return { goalData: goalData };
  }
}

const goalModule = getModule(GoalModule);
export default goalModule;
